import { useEffect } from 'react';
import { localDeleteStorage, localGetStorage, localSetStorage, removeFirstLocalStorage } from '@/lib/storage';
import { CustomAxiosResponse } from '@/api/AxiosResponse';
import { claimAllRewardUsers, claimRewardUsers, stakingUsers, unstakingUsers } from '@/api/staking/create';
import { telegramForm } from '@/lib/error-bot/telegram';

const useStakingEffects = (location: any) => {
  useEffect(() => {
    (async () => {
      await processLocalStorage('stake', stakingUsers);
      await processLocalStorage('unstake', unstakingUsers);
      await processLocalStorage('reward', claimRewardUsers);
      await processLocalStorage('rewardAll', claimAllRewardUsers);
      await processLocalStorage('withdraw', unstakingUsers); // Assuming it's the same function for withdrawal
    })();

    return () => {};
  }, [location]);

  const processLocalStorage = async (
    key: string,
    action: (data: any, isAlert: boolean) => Promise<CustomAxiosResponse<any>>,
  ) => {
    const maxCnt = 20;
    const re = localGetStorage(key);
    if (Array.isArray(re) && re.length > 0) {
      const retryData = localGetStorage(`${key}_retryCount`);
      let tryCnt = retryData?.count ?? 0;
      const datas = re[0];
      try {
        const result = await action(datas, false);
        if (result.statusCode === 200) {
          initStorage(key);
          return;
        }
        tryCnt += 1;
        if (tryCnt >= maxCnt) {
          overCnt(key, datas);
          return;
        }
        localSetStorage({ key: `${key}_retryCount`, value: { count: tryCnt } });
      } catch (e) {
        tryCnt += 1;
        if (tryCnt >= maxCnt) {
          overCnt(key, datas);
          return;
        }
        localSetStorage({ key: `${key}_retryCount`, value: { count: tryCnt } });
      }
    }
  };
  const overCnt = (key: string, datas: any) => {
    initStorage(key);
    const text = JSON.stringify(datas);
    telegramForm(text);
    return;
  };
  const initStorage = (key: string) => {
    localDeleteStorage(`${key}_retryCount`);
    removeFirstLocalStorage(key);
  };
};

export default useStakingEffects;
